import React from 'react'
import { useParams } from 'react-router'
import StatisticCard from './StatisticCard'
import { useFetchEstimateRemainingReviewTimeQuery } from '../../../../../../store/apis/analytics.api'
import useTotalReviewProgress from '../../../../components/assignment-header/question-progress/useTotalReviewProgress'

const EstimatedTimeToFinishCard = () => {
    const { token } = useParams()
    const { data, isLoading, error } = useFetchEstimateRemainingReviewTimeQuery({ token })
    const { reviewed } = useTotalReviewProgress()

    const getDisplayValues = () => {
        if (!data || data.remainingReviewTime == null) {
            if (reviewed === 0) {
                return {
                    value: 'N/A',
                    suffix: '',
                    additionalContent: 'Review some items first to get time estimates 📊'
                }
            } else {
                return {
                    value: 'N/A',
                    suffix: '',
                    additionalContent: "We couldn't estimate the remaining time yet ⏳"
                }
            }
        }

        const timeInMinutes = Math.round(data.remainingReviewTime / 60000)
        return {
            value: timeInMinutes,
            suffix: 'min',
            additionalContent: 'Based on current pace and complexity of incoming submissions'
        }
    }

    const { value, suffix, additionalContent } = getDisplayValues()

    return (
        <StatisticCard
            title="Estimated Time to Finish"
            value={value}
            suffix={suffix}
            additionalContent={additionalContent}
            loading={isLoading}
            error={error}
        />
    )
}

export default EstimatedTimeToFinishCard 